module.exports = __webpack_public_path__ + "static/img/footer-logo.325ded8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-logo.png
// module id = DSQX
// module chunks = 19